"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSelect = void 0;
var palette_1 = require("../../../theme/global/palette");
exports.MuiSelect = {
    select: {
        '&:focus': {
            backgroundColor: palette_1.palette.common.white,
        },
    },
    icon: {
        top: 'unset',
        fill: palette_1.palette.common.black,
        '&$disabled': {
            fill: palette_1.palette.grey[400],
        },
    },
    iconOutlined: {
        right: 16,
        width: 16,
    },
};
